module.exports = __webpack_public_path__ + "static/media/portfolio_site_la_london_1.39fe5927.png";